import { sendWhatsAppTemplate } from '../services/whatsapp.service'

export function sanitizeWhatsAppText(text) {
  return String(text ?? '')
    .replace(/\\[nrt]/g, ' ')
    .replace(/[\n\r\t]+/g, ' ')
    .replace(/ {2,}/g, ' ')
    .trim()
}

export function formatWhatsAppPhone(phone) {
  return String(phone ?? '')
    .replace('+', '')
    .trim()
}

export function buildWhatsAppLegacyLog(recipient, error = '') {
  return {
    recipient: formatWhatsAppPhone(recipient),
    error,
  }
}

export function buildWhatsAppLegacyPayload(recipient, sent, error = '') {
  return {
    sent: sent ? 1 : 0,
    not_sent: sent ? 0 : 1,
    logs: [buildWhatsAppLegacyLog(recipient, error)],
  }
}

export function buildWhatsAppLegacyResponse(payload) {
  return {
    ok: Boolean(payload.sent),
    status: payload.sent ? 200 : 500,
    json: async () => payload,
  }
}

export async function sendCurrentWhatsAppMessage({ to, template, params }) {
  if (!template) {
    throw new Error('YCloud solo permite el envío de plantillas aprobadas en este flujo.')
  }

  const payload = {
    to: formatWhatsAppPhone(to),
    template,
    params,
  }

  return sendWhatsAppTemplate(payload, { useTestEndpoint: false })
}
